import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { useLocation } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
// import './Salary.css';

function SalaryDetails() {
  const [startDate, setStartDate] = useState(new Date());
  const [schoolName, setSchoolName] = useState(''); // State for company name
  const [companyAddress, setCompanyAddress] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [earnings, setEarnings] = useState([
    { name: 'Basic', amount: 0 }, // Default value for Basic
    { name: 'HRA', amount: 0 },   // Default value for HRA
    { name: 'DA', amount: 0 },     // Default value for DA
    { name: 'Bonus', amount: 0},
    { name: 'Incentive', amount: 0},
    { name: 'Overtime', amount: 0},
    { name: 'Otherearning', amount: 0},
]);
  const [deductions, setDeductions] = useState([
    {name: 'PF', amount: 0 },
    {name: 'ESI', amount: 0},
     {name: 'Otherdeduction', amount:0}]); // Default values for PF and
  const location = useLocation(); // Get the location object
  const queryParams = new URLSearchParams(location.search);
  const adminmob = queryParams.get('adminmob'); // Extract adminmob from query params
  const branchId = queryParams.get('branchId');
  const empmobile = queryParams.get('empmobile');
  const [basicSalary, setBasicSalary] = useState(0);
  const [paymentType, setPaymentType] = useState('PerMonth'); 
  const [newEarnings, setNewEarnings] = useState([]);
  const [newDeductions, setNewDeductions] = useState([]);
  const [showTable, setShowTable,] = useState(false);
  const [Address, setaddress] = useState(0);
  const [bank_name, setbankName] = useState(0);
  const [ifsc, setifscCode] = useState(0);
  const [accnumber, setaccountNumber] = useState(0);
  const [calpf, setPF] = useState(0);
  const [calesi, setESI] = useState(0);
  const [EMI, setEmi] = useState(0);
  const [hra, setHra] = useState(0);
  const [da, setDa] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [incentive, setIncentive] = useState(0);
  const [overtime, setOvertime] = useState(0);
  const [otherearn, setOtherearn] = useState(0);
  const [PF, setPf] = useState(0);
  const [ESI, setEsi] = useState(0);
  const [otherdedu, setotherDeduction] = useState(0);
  const [Bank, setBank] = useState('');
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [panNumber,setPanNumber] = useState('');
  // New state variables for attendance counts
  const [presentCountValue, setPresentCountValue] = useState(0);
  const [absentCountValue, setAbsentCountValue] = useState(0);
  const [halfDayCountValue, setHalfDayCountValue] = useState(0);
  const [monthDays, setMonthDays] = useState(0);
  const [proportionalSalary, setProportionalSalary] = useState(0);
  const udiseNumber= localStorage.getItem("udiseNumber")
   const navigate = useNavigate();
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  
        useEffect(() => {
                   const storedLanguage = localStorage.getItem('language') || 'English';
                   setLanguage(storedLanguage);
                 }, []);
  
  
  const handleDateChange = (date) => {
    setStartDate(date);
  };

  // Function to format the date to show full month name
  const formatDate = (date) => {
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  const addEarning = () => {
    const newEarning = { name: '', amount: '' };
    setEarnings([...earnings, newEarning]);
    setNewEarnings([...newEarnings, newEarning]); // Track new earnings
  };

  const addDeduction = () => {
    const newDeduction = { name: '', amount: '' };
    setDeductions([...deductions, newDeduction]);
    setNewDeductions([...newDeductions, newDeduction]);
  }

  useEffect(() => {
    const fetchSchoolName = async () => {
console.log("fetchschoolname",fetchSchoolName);

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/SchoolName.json`;
console.log("url",url);

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setSchoolName(data.School); // Set the company name from the response
        setCompanyAddress(data.Location);
      } catch (error) {
        console.error('Error fetching company name:', error);
      }
    };

    fetchSchoolName();
  }, [adminmob,branchId]);


  useEffect(() => {
    const fetchPan = async () => {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/TeacherDetails.json`;
    try{
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setPanNumber(data.pancardnumber);
    } catch (error) {
      console.error('Error fetching company name:', error);
    }
    };
    fetchPan();
  },[adminmob,branchId]);

useEffect(() => {
  const fetchEmployeeName = async () => {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
console.log("url",url);

    try{
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
    }
    const data = await response.json();
    setEmployeeName(data.Name);
}catch (error){
console.error('Error fetching employee name:', error);
}
  };
  fetchEmployeeName();
  }, [adminmob,udiseNumber] );


  useEffect(() => {
    const fetchEmployeeId = async () => {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Currentteacher.json`;
  console.log("url",url);
  
      try{
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setEmployeeId(data.EmployeeID);
  }catch (error){
  console.error('Error fetching employee name:', error);
  }
    };
    fetchEmployeeId();
    }, [adminmob,udiseNumber] );
    
    useEffect(() => {
      const fetchSalaryDetails = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/SalaryDetails/${paymentType}.json`;
        console.log("url", url);
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.json();
          console.log("data", data);
  
          setBasicSalary(data.basicsalary); // Set the basic salary
          setHra(data.hra); // Set the hra
          setDa(data.da); // Set the da
          setBonus(data.bonus); // Set bonus
          setIncentive(data.incentive); // Set Incenitive
          setOvertime(data.overtime); // Set overtime
          setOtherearn(data.otherearn); // Set otherearning
          setEmi(data.EMI);
          setEarnings([
            { name: 'Basic', amount: data.basicsalary },
            { name: 'HRA', amount: data.hra },
            { name: 'DA', amount: data.da },
            { name: 'Bonous', amount: data.bonus },
            { name: 'Incentive', amount: data.incentive },
            { name: 'Overtime', amount: data.overtime },
            { name: 'Otherearning', amount: data.otherearn },
            { Emi: data.EMI || 0, }
  
          ]);
  
          setPf(data.PF); // SetPF
          console.log("data.PF",data.PF);
          
          setEsi(data.ESI); // Set ESI
          setotherDeduction(data.otherdedu);
          setPF(data.calpf); // Set
          setESI(data.calesi); // Set ESI
          setDeductions([
            { name: 'PF (%)', amount: data.PF }, // Change to percentage
            { name: 'ESI (%)', amount: data.ESI }, // Change to percentage
            // {calpf: data.calpf || 0,
            //   calesi: data.calesi || 0,},
            { name: 'Otherdeduction', amount: data.otherdedu },
  
  
  
          ]);
        } catch (error) {
          console.error('Error fetching salary details:', error);
        }
      };
  
      fetchSalaryDetails();
    }, [adminmob, branchId, empmobile, paymentType]); // Add paymentType to the dependency array

    useEffect(() => {
      const fetchBank = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Bank.json`;
        console.log("Fetching Bank Details from:", url);
  
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          console.log("Bank :", data);
  
          setbankName(data.bank_name);
          setifscCode(data.ifsc);
          setaccountNumber(data.accnumber);
          setBank({
            bankName: data.bank_name,
            ifscCode: data.ifsc,
            accountNumber: data.accnumber,
            accountHolderName: data.accountholdername,
            upiId: data.upiid,
          });
        } catch (error) {
          console.error("Error fetching bank details:", error);
        }
      };
  
      fetchBank();
    }, [adminmob, branchId, empmobile]);

    useEffect(() => {
      const fetchEmployeeDetails = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/SchoolName.json`;
        console.log("Fetching Employee Details from:", url);
  
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          console.log("Employee Details:", data);
  
          setaddress(data.Location);
          setEmployeeDetails({
  
            address: data.Location || "N/A",
          });
        } catch (error) {
          console.error("Error fetching employee details:", error);
        }
      };
  
  
      fetchEmployeeDetails();
    }, [adminmob, branchId, empmobile]);

    useEffect(() => {
      const fetchAttendanceCounts = async () => {
        const attendanceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/${startDate.toLocaleString('default', { month: 'short' }).replace('.', '') + startDate.getFullYear()}/acount.json`;
        try {
          const response = await fetch(attendanceUrl);
          if (!response.ok) {
            throw new Error('Failed to fetch attendance data');
          }
          const absentCount = await response.json();
          setAbsentCountValue(absentCount || 0);
        } catch (error) {
          console.error('Error fetching attendance counts:', error);
          setAbsentCountValue(0); // Set default value if error occurs
        }
      };
      fetchAttendanceCounts();
    }, [adminmob, branchId, empmobile, startDate]);


    useEffect(() => {
      const fetchHalfDayCounts = async () => {
          // Format the month as 'MMMYYYY' (e.g., 'Nov2024')
          const month = startDate.toLocaleString('default', { month: 'short' }).replace('.', '') + startDate.getFullYear(); // Get abbreviated month and year
          const fetchHalfDayCountsurl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/${month}/hcount.json`; // Update the URL to point to the correct path
          console.log("fetchHalfDayCountsurl", fetchHalfDayCountsurl);
          
          try {
              const response = await fetch(fetchHalfDayCountsurl);
              if (response.ok) {
                  const halfdaycount = await response.json(); // Fetch the absent count directly
                  setHalfDayCountValue(halfdaycount || 0); // Set the absent count value
                  console.log("Fetched halfday count:", halfdaycount); // Log the fetched absent count
              } else {
                  console.error("Failed to fetch halfday data:", response.statusText);
              }
          } catch (error) {
              console.error("Error fetching halfday counts:", error);
          }
      };
    
      fetchHalfDayCounts();
    }, [adminmob, branchId, empmobile, startDate]); // Add startDate to the dependency array

   useEffect(() => {
      const fetchPresentDayCounts = async () => {
        const year = startDate.getFullYear();
        const attendanceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Attendance.json`;
        console.log("attendanceUrl", attendanceUrl);
        try {
          const response = await fetch(attendanceUrl);
          if (response.ok) {
            const attendanceData = await response.json();
            console.log("attendanceData", attendanceData);
    
            if (attendanceData) {
              console.log("attendanceData is not null or undefined");
              let paidDaysCount = 0;
              let halfDayCount = 0;
              Object.keys(attendanceData).forEach((date) => {
                const attendanceStatus = attendanceData[date].status;
                const dateParts = date.split('-');
                if (dateParts[0] === year.toString() && dateParts[1] === startDate.toLocaleString('default', { month: '2-digit' })) {
                  if (attendanceStatus === "Full") {
                    paidDaysCount++;
                  } else if (attendanceStatus === "Half") {
                    halfDayCount++;
                  }
                }
              });
              console.log("Paid Days Count:", paidDaysCount);
              console.log("Half Day Count:", halfDayCount);
              setPresentCountValue(paidDaysCount);
              setHalfDayCountValue(halfDayCount);
            } else {
              console.log("attendanceData is null or undefined");
              setPresentCountValue(0); // Set default value if attendanceData is null or undefined
              setHalfDayCountValue(0); // Set default value if attendanceData is null or undefined
            }
          } else {
            console.error("Failed to fetch attendance data:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching attendance counts:", error);
        }
      };
    
      fetchPresentDayCounts();
    }, [adminmob, branchId, empmobile, startDate]);

    useEffect(() => {
      // Calculate the number of days in the selected month
      const daysInMonth = calculateDaysInMonth(startDate);
      setMonthDays(daysInMonth); // Set the month days state
    }, [startDate]);

    useEffect(() => {
      // Calculate the proportional salary
      if (monthDays > 0) { // Ensure monthDays is not zero to avoid division by zero
        const totalSalary = calculateTotalSalary();
        const calculatedProportionalSalary = (totalSalary / monthDays) * (presentCountValue + (halfDayCountValue / 2)); // Calculate proportional salary
        setProportionalSalary(calculatedProportionalSalary); // Update the state
      } else {
        setProportionalSalary(0); // Reset if monthDays is zero
      }
    }, [presentCountValue, monthDays, halfDayCountValue]);

    const calculateTotalEarnings = () => {
    return earnings.reduce((total, earning) => {
      const amount = parseFloat(earning.amount) || 0; // Convert to number, default to 0 if NaN
      return total + amount;
    }, 0);
  };
  const calculateTotalAmountPer = () => {
    return earnings.reduce((total, earning) => {
      // console.log("total",total);
      // console.log("earning",earning);
      if(earning.name === "Basic"){
        console.log("amount of basic= ",earning.amount);
        return earning.amount;
      }
    }, 0);
  };
  calculateTotalAmountPer();
  const calculateTotalDeductions = () => {
    return deductions.reduce((total, deduction) => {
      const amount = (basicSalary * (parseFloat(deduction.amount) / 100)) || 0; // Calculate based on percentage
      return total + amount;
    }, 0);
  };

  const calculateTotalSalary = () => {
    return calculateTotalEarnings() - calculateTotalDeductions();
  };
  
  const calculateDaysInMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth(); // 0-indexed month
  return new Date(year, month + 1, 0).getDate(); // Get the last day of the month
};

const saveSalaryDetails = async () => {

  // Get the PF and ESI amounts and ensure they are formatted correctly
  const pfPercentage = deductions.find(d => d.name === 'PF (%)')?.amount || 0;
  console.log("pfPercentage",pfPercentage);
  const esiPercentage = deductions.find(d => d.name === 'ESI (%)')?.amount || 0;
  

  // Calculate the amounts based on the basic salary
  const calpf = (basicSalary * (parseFloat(pfPercentage) / 100)) || 0; // Calculate PF amount
  const calesi = (basicSalary * (parseFloat(esiPercentage) / 100)) || 0; // Calculate ESI amount

  // Format the amounts to include the percentage sign if they are not already formatted
  const formattedPF = `${pfPercentage}%`;
  const formattedESI = `${esiPercentage}%`;
  console.log("formattedPF",formattedPF);
  console.log("formattedESI",formattedESI);
  
  // Create an allowance object that only includes the new earnings
  const allowance = {
    ...newEarnings.reduce((acc, earning) => {
      if (earning.name && earning.amount) {
        acc[earning.name] = earning.amount; // Use the earning name as the key
      }
      return acc;
    }, {}),
    // Include existing allowance if needed
    ...Object.entries(earnings.reduce((acc, earning) => {
      if (earning.name !== 'Basic' && earning.name !== 'HRA' && earning.name !== 'DA' && earning.name !== 'Bonus' && earning.name !== 'Incentive' && earning.name !== 'Overtime' && earning.name !== 'Otherearning') {
        acc[earning.name] = earning.amount; // Include existing allowance
      }
      return acc;
    }, {})).reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {})
  };

  // Create a deduction object that only includes the new deductions
  let existingDeductions = {};
  try {
    const existingResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/SalaryDetails/${paymentType}.json`);
    if (existingResponse.ok) {
      const existingData = await existingResponse.json();
      existingDeductions = existingData.Deduction || {};
    }
  } catch (error) {
    console.error('Error fetching existing deductions:', error);
  }

  // Create a deduction object that only includes the new deductions
  const deduction = {
    ...existingDeductions, // Include existing deductions
    ...newDeductions.reduce((acc, newDeduction) => {
      if (newDeduction.name && newDeduction.amount) {
        acc[newDeduction.name] = newDeduction.amount; // Use the deduction name as the key
      }
      return acc;
    }, {}),
  };

  const salaryDetails = {
    Allowance: allowance, // Only new earnings will be saved here
    basicsalary: earnings.find(e => e.name === 'Basic')?.amount || 0,
    hra: earnings.find(e => e.name === 'HRA')?.amount || 0,
    da: earnings.find(e => e.name === 'DA')?.amount || 0,
    bonus: earnings.find(e => e.name === 'Bonous')?.amount || 0,
    incentive: earnings.find(e => e.name === 'Incentive')?.amount || 0,
    overtime: earnings.find(e => e.name === 'Overtime')?.amount || 0,
    otherearn: earnings.find(e => e.name === 'Otherearning')?.amount || 0,
    Deduction: deduction, // Include the new deductions
    PF: formattedPF, // Use the formatted PF
    ESI: formattedESI, // Use the formatted ESI
    otherdedu: deductions.find(e => e.name === 'Otherdeduction')?.amount || 0,
    calpf: calpf.toFixed(2), // Save PF amount with key calpf
    calesi: calesi.toFixed(2), // Save ESI amount with key calesi
  };

  const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/SalaryDetails/${paymentType}.json`;

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(salaryDetails),
    });

    if (!response.ok) {
      throw new Error('Failed to save salary details');
    }

    alert('Salary details saved successfully!');
    setNewEarnings([]); // Clear new earnings after saving
    setNewDeductions([]); // Clear new deductions after saving
  } catch (error) {
    console.error('Error saving salary details:', error);
    alert('Error saving salary details. Please try again.');
  }
};

const handleShowTable = () => {
  if (window.confirm("Are you sure you want to preview the salary report?")) {
  setShowTable(true);
  }
};

const handleCloseTable = () => {
  setShowTable(false);
};

const handlePrint = () => {
  const printContent = document.querySelector('.modal-content');

  if (printContent) {
    const cloneContent = printContent.cloneNode(true);

    const schoolName = cloneContent.querySelector('p'); 
    const otherDetails = cloneContent.querySelectorAll('p'); 
    otherDetails.forEach((p, index) => {
      if (index !== 0) { 
        p.style.fontWeight = 'normal'; 
      }
    });

    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Modal Content</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 5mm; /* Set left margin */
              
               border:1px solid black;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0; /* Remove body margin */
            }
            .modal-content {
           
              margin: 20px; /* Add margin to the modal content */
            }
            thead {
                          background-color: #F0F0F0; /* Set very light gray background color for <thead> */

            }
          </style>
        </head>
        <body>
          ${cloneContent.outerHTML} <!-- Include the modified outer HTML of the modal content -->
        </body>
      </html>
    `);
    printWindow.document.close(); 
    printWindow.focus(); // Focus the new window
    printWindow.print(); // Trigger print
    printWindow.close(); // Close the print window after printing
  } else {
    console.error('Print content not found');
  }
};

const handleClose = () => {
  navigate(-1);
};

  return (
      <div className='main-content-of-page'>
      <div style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
}}>
  <div style={{ flex: 1, textAlign: 'center' }}>
    <h2 style={{
      color: '#03365e',
      fontWeight: '600',
      textAlign: 'center'
    }}>
     {language === "English" ? " Salary Details" : "पगार तपशील"}
    </h2>
  </div>
  <div style={{
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }}>

<button
  onClick={handleShowTable}
  style={{
    backgroundColor: "#03365e",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    marginRight: '20px' // Add space between buttons
  }}
>
   {language === "English" ? " Salary Report" : "पगार अहवाल"}
</button>
<button style={{
  backgroundColor: '#dc3545',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  fontSize: '20px',
  fontWeight: 'bold'
}} onClick={handleClose}>
  X
</button>
  </div>
</div>
        <div style={{display:'flex', justifyContent: 'space-between', width: '100%', paddingTop:'15px'}}>
  <div style={{marginTop:'0px', marginLeft:'40px'}}>
    <label> {language === "English" ? "Select Month and Year:" : "महिना आणि वर्ष निवडा:"} </label>
    <DatePicker
      selected={startDate}
      onChange={handleDateChange}
      showMonthYearPicker
      dateFormat="MM/yyyy" 
      customInput={
        <input 
          value={formatDate(startDate)} 
          readOnly 
          style={{ cursor: 'pointer', width: '55%', padding: '9px', borderRadius: '5px', marginLeft: '10px', paddingLeft: '20px', height: '37px' }} 
        />
      }
    />
  </div>
  <div>
  <label style={{ marginLeft: '30px' }}>
    <input
      type="radio"
      id="month"
      name="pmonth"
      value="PerMonth"
      checked={paymentType === 'PerMonth'}
      onChange={() => setPaymentType('PerMonth')}
      style={{ display: 'none' }} 
    />
    <span className="custom-radio"></span> 
   {language === "English" ? " Per Month" : "दरमहा"}
  </label>

  <label style={{ marginLeft: '30px' }}>
    <input
      type="radio"
      id="day"
      name="pmonth"
      value="PerDay"
      checked={paymentType === 'PerDay'}
      onChange={() => setPaymentType('PerDay')}
      style={{ display: 'none' }} 
    />
    <span className="custom-radio"></span> {/* Custom circle */}
   {language === "English" ? "  Per Day" : "प्रतिदिन"}
  </label>

  <label style={{ marginLeft: '30px' }}>
    <input
      type="radio"
      id="hour"
      name="pmonth"
      value="PerHour"
      checked={paymentType === 'PerHour'}
      onChange={() => setPaymentType('PerHour')}
      style={{ display: 'none' }} // Hide the default radio button
    />
    <span className="custom-radio"></span> {/* Custom circle */}
  {language === "English" ? "Per Hour " : "प्रति तास"}
  </label>
  <style jsx>{
    `    
    .custom-radio {
  display: inline-block;
  width: 14px; /* Size of the circle */
  height: 14px; /* Size of the circle */
  border-radius: 50%; /* Make it a circle */
  border: 2px solid #ccc; /* Default border color */
  margin-right: 5px; /* Space between circle and label */
  vertical-align: middle; /* Align with text */
  transition: background-color 0.3s; /* Smooth transition */
}

input[type="radio"]:checked + .custom-radio {
  background-color: rgb(3, 54, 94); /* Change to blue when selected */
  border: 2px solid rgb(3, 54, 94); /* Optional: Change border color */
}`}
  </style>
</div>
  <div style={{marginTop:'5px', marginLeft: 'auto', textAlign:'right', marginRight:'20px'}}>
    <h4>{schoolName}</h4>
    <p style={{width:'50%', marginLeft:'50%'}}>{companyAddress || " "}</p>
  </div>

</div>
       <hr/>

       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px',paddingTop: '10px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)', width: '86%', margin:'auto'}}>
  <h4 style={{ color: '#03365e', fontWeight: '600', marginBottom: '0px' }}>{language === "English" ? "Salary Report " : "पगार अहवाल"}</h4>
  
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '20px', width: '90%', maxWidth: '800px', margin: 'auto' }}>
  <div style={{ flex: 1, marginRight: '20px', backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)' }}>
    <h4 style={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'center' }}>{language === "English" ? "Employee Pay Summary " : "शिक्षक वेतन सारांश"}</h4>
    <div style={{ marginBottom: '20px'}}>
      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
        <tbody>
          <tr>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}> {language === "English" ? "Teacher Name " : "शिक्षकाचे नाव"}</label>
              <input
                type="text"
                name="pay period"
                value={employeeName}
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc', width: '100%' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "teacher ID " : "शिक्षक आयडी"}</label>
              <input
                type="text"
                name="pay period"
                value={employeeId}
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc' }}>
              <label  style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "Pay Period" : "वेतन कालावधी"}</label>
              <input
                type="date"
                name="pay period"
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc', width: '100%' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "Paid Days" : "उपस्थित दिवस"}</label>
              <input
                type="number"
                name="pay period"
                value={presentCountValue}
                readOnly
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "Absent Days" : "अनुपस्थित दिवस"}</label>
              <input
                type="number"
                name="pay period"
                value={absentCountValue}
                readOnly
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc', width: '100%' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "Half Day Count" : "अर्धा दिवस संख्या"}</label>
              <input
                type="number"
                name="pay period"
                value={halfDayCountValue}
                readOnly
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "Loss Of Pay Days" : "वेतनाच्या दिवसांचे नुकसान"}</label>
              <input
                type="number"
                name="pay period"
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
            <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ccc' }}>
              <label style={{fontWeight:'600',  marginLeft: '10px'}}>{language === "English" ? "Pay Date" : "पे तारीख"}</label>
              <input
                type="date"
                name="pay period"
                style={{
                  marginLeft: '10px',
                  width: '230px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center',
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style={{ flex: 1, marginLeft: '20px', backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)' }}>
    <h4 style={{ marginTop: '0%', fontWeight: 'bold', textAlign: 'center', fontSize:'18px' }}>{language === "English" ? "Income Details" : "उत्पन्नाचा तपशील"}</h4>
    <div style={{ display: 'flex' }}>
      <div>
        <table style={{ borderCollapse: 'collapse', width: '100%'}}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>{language === "English" ? "Earnings" : "कमाई"}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>{language === "English" ? "Amount" : "रक्कम"}</th>
            </tr>
          </thead>
          <tbody>
            {earnings.map((earning, index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #ccc', padding: '8px',display:'flex', width:'100%' }}>
                  <input
                    type="text"
                    placeholder="Earning Name"
                    value={earning.name}
                    onChange={(e) => {
                      const newEarnings = [...earnings];
                      newEarnings[index].name = e.target.value;
                      setEarnings(newEarnings);
                    }}
                    style={{ border: 'none',
                  width: '140px',
                  padding: '5px',
                  borderBottom: '1px solid gray' }}/>
                   {index > 2 && (
        <button
          style={{
            backgroundColor:'white',
            color: 'black',
            padding: '2px 5px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            marginLeft: '5px',
            fontWeight:'bold'
          }}
          onClick={() => {
            const newEarnings = [...earnings];
            newEarnings.splice(index, 1);
            setEarnings(newEarnings);
          }}
        >
          X
        </button>
      )}
    </td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                  <input
                    type="number"
                    value={earning.amount}
                    onChange={(e) => {
                      const newEarnings = [...earnings];
                      newEarnings[index].amount = e.target.value;
                      setEarnings(newEarnings);
                    }}
                    style={{ border: '1px solid #ccc', width: '140px',
                  padding: '5px',
                  borderRadius: '5px' }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button 
  onClick={addEarning} 
  style={{
    marginTop: '5px', 
    marginBottom: '10px', 
    padding: '5px 10px', // Increased padding for a larger button
    borderRadius: '6px', 
    backgroundColor: '#03365e', // Green background color
    color: 'white', // White text color
    border: 'none', // Remove default border
    fontSize: '16px', // Increase font size
    cursor: 'pointer', // Change cursor to pointer
    transition: 'background-color 0.3s, transform 0.2s', // Smooth transition for hover effects
  }}
>
  {language === "English" ? "Add Earnings" : "कमाई भरा"}
</button>
        <tr>
          <td style={{ border: '1px solid #ccc', padding: '8px', width: '160px', }}>{language === "English" ? "Gross Earnings " : "एकूण कमाई"}</td>
          <td style={{ border: '1px solid #ccc', padding: '8px' }}>
            <input
              type="number"
              value={calculateTotalEarnings()}
              readOnly 
              style={{ border: '1px solid #ccc', width: '140px',
                  padding: '5px',
                  borderRadius: '5px' }}
            />
          </td>
        </tr>
      </div>

      <div style={{ marginLeft: '20px' }}>
        <table style={{ borderCollapse: 'collapse', width: '80%', border: '1px solid #ccc' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>{language === "English" ? "Deductions" : "वजा केलेली रक्कम"}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>{language === "English" ? "Per (%)" : "टक्केवारी (%)"}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>{language === "English" ? "Amount" : "रक्कम"}</th>
            </tr>
          </thead>
          <tbody>
            {deductions.map((deduction, index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #ccc', padding: '8px',display:"flex",width:'100%' }}>
                  <input
                    type="text"
                    placeholder="Deduction Name"
                    value={deduction.name}
                    onChange={(e) => {
                      const newDeductions = [...deductions];
                      newDeductions[index].name = e.target.value;
                      setDeductions(newDeductions);
                    }}
                    style={{ border: 'none',
                  width: '140px',
                  padding: '5px',
                  borderBottom: '1px solid gray' }}
                  />
                  {index > 2 && (
        <button
          style={{
            backgroundColor:'white',
            color: 'black',
            padding: '2px 5px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            marginLeft: '5px',
            fontWeight:'bold'
          }}
          onClick={() => {
            const newDeductions = [...deductions];
            newDeductions.splice(index, 1);
            setDeductions(newDeductions);
          }}
        >
          X
        </button>
      )}
                </td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                  <input
                    type="number"
                    placeholder="Percentage"
                    value={(parseFloat(deduction.amount) ) || 0} 
                    onChange={(e) => {
                      const newDeductions = [...deductions];
                      newDeductions[index].amount = e.target.value;
                      setDeductions(newDeductions);
                    }}
                    style={{ border: '1px solid #ccc', width: '60px',
                  padding: '5px',
                  borderRadius: '5px', }}
                  />
                </td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                  <input
                    type="number"
                    value={(basicSalary * (parseFloat(deduction.amount) / 100)) || 0} 
                    readOnly
                    style={{ border: '1px solid #ccc', width: '120px',
                  padding: '5px',
                  borderRadius: '5px', }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={addDeduction}  style={{
    marginTop: '5px', 
    marginBottom: '10px', 
    padding: '5px 10px',
    borderRadius: '6px', 
    backgroundColor: '#03365e', // Green background color
    color: 'white', 
    border: 'none', // Remove default border
    fontSize: '16px', // Increase font size
    cursor: 'pointer', // Change cursor to pointer
    transition: 'background-color 0.3s, transform 0.2s', // Smooth transition for hover effects
  }}
>
         {language === "English" ? " Add Deductions" : "कपात भरा"}
        </button>
        <tr>
          <td style={{ border: '1px solid #ccc', padding: '8px', width: '160px', }}>{language === "English" ? "Total Deductions" : "एकूण कपात"}</td>
          <td style={{ border: '1px solid #ccc', padding: '8px' }}>
            <input
              type="number"
              value={calculateTotalDeductions()} // Use the calculated total here
              readOnly 
              style={{ border: '1px solid #ccc', width: '190px',
                  padding: '5px',
                  borderRadius: '5px' }}
            />
          </td>
        </tr>
      </div>
    </div>
  </div>
</div>


  
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <button onClick={saveSalaryDetails} style={{
    marginTop: '5px', 
    marginBottom: '10px', 
    padding: '7px 13px', // Increased padding for a larger button
    borderRadius: '4px', 
    backgroundColor: '#03365e', // Green background color
    color: 'white', // White text color
    border: 'none', // Remove default border
    fontSize: '16px', float:'left',marginRight:'100px', marginLeft:'0px', // Increase font size
    cursor: 'pointer', // Change cursor to pointer
    transition: 'background-color 0.3s, transform 0.2s', // Smooth transition for hover effects
  }}
>Save</button>
        <label style={{ marginRight: '10px' }}>{language === "English" ? "Total salary" : "एकूण पगार"}</label>
        <input type="text" name='total salary' value={calculateTotalSalary()}  style={{ border: '1px solid #ccc', width: '130px', padding: '0px 5px', borderRadius: '5px', height:'40px', textAlign:'center', marginRight:'50px' }} />
        
        <label style={{ marginRight: '10px' }}>{language === "English" ? "Month Days" : "महिन्याचे दिवस"}</label>
        <input type="text" name='month days' value={monthDays}  style={{ border: '1px solid #ccc', width: '130px', padding: '0px 5px', borderRadius: '5px', height:'40px', textAlign:'center', marginRight:'50px' }} />

        <label style={{ marginRight: '10px' }}>Proportional Salary</label>
        <input type="text" name='proportional salary' value={proportionalSalary}  style={{ border: '1px solid #ccc', width: '130px', padding: '0px 5px', borderRadius: '5px', height:'40px', textAlign:'center' }} />
      </div>
      
</div>
       {showTable && (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

            }}
          >
          
            <div 
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                width: "100%",
                height: "100%",
                maxHeight: "1000px",
                maxWidth: "1200px",
                overflowY: "auto",
                paddingLeft: "50px",
                paddingRight: "50px",
                paddingTop: "70px",


              }}
            >
              <div className="modal-content">
              <div className="head">
                <h1 style={{ textAlign: "center",fontSize:'25px',fontWeight:"bold" }}>{language === "English" ? "Salary Report" : "पगार अहवाल"}</h1>

                <div style={{ marginTop: "20px", fontSize: "20px", color: "#333", fontWeight: "bold" }}>
                  {showTable}
                </div>
                {/* <img src={logo} alt="Logo" /> */}

              </div>



              <div style={{ width: "100%", margin: "auto" }}>

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                    border: "1px solid black",
                    textAlign: "left",
                  }}
                >
                  <thead>
                  <tr>
    <th colSpan={1} style={{ border: "none", padding: "8px",fontWeight:"bold", backgroundColor:'rgba(85, 85, 85, 0.1)' }}>
     {language === "English" ? " Name :" : "नाव :"}
    </th>
    <td colSpan={2}>{employeeName}</td>
    <th colSpan={1} style={{ border: "none", padding: "8px",fontWeight:"bold", backgroundColor:'rgba(85, 85, 85, 0.1)' }}>
      {language === "English" ? "  School Name :" : "शाळेचे नाव :"}
    </th>
    <td colSpan={2}>{schoolName}</td>
  </tr>
                    <tr>
                      <th colSpan="2" style={{ border: "1px solid black", padding: "8px", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)' }}>
                        {language === "English" ? " Teacher Details :" : "शिक्षक माहिती :"}
                      </th>
                      <th colSpan="2" style={{ border: "1px solid black", padding: "8px", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)' }}>
                        {language === "English" ? "Payment & Leave Details" : "पेमेंट आणि रजा तपशील :"}
                      </th>
                      <th colSpan="2" style={{ border: "1px solid black", padding: "8px", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)' }}>
                        {language === "English" ? " Location Details " : "जागा माहिती :"}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {/* <td>{employeeName}</td> */}
                      <td style={{ border: "1px solid black", padding: "8px" }}> {language === "English" ? " Teacher ID " : "शिक्षक आयडी :"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {employeeId}




                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Bank Name" : "बँकेचे नाव :"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{bank_name}

                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Location" : "ठिकाण :"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{Address}

                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Grade" : "ग्रेड :"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>

                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Acc.NO" : "खाते क्रमांक :"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{accnumber}

                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "P.Days" : "उ.दिवस:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{presentCountValue}

                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Pan No." : "पॅन क्र.:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{panNumber}</td>

                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Days Paid" : "उपस्थित दिवस:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{presentCountValue}

                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "H.Days" : "अर्धा दिवस:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{halfDayCountValue}

                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Tax" : "कर:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>

                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "Leave Balance" : "शिल्लक रजा:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>

                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{language === "English" ? "A.Days" : "अनु. दिवस:"}</td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>

                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "16px",
                    textAlign: "left",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: "10px", border: "1px solid black", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)' }}>{language === "English" ? "Earnings" : "कमाई:"}</th>
                      <th style={{ padding: "10px", border: "1px solid black",fontWeight:"bold", backgroundColor:'rgba(85, 85, 85, 0.1)'}}>Current</th>
                      <th style={{ padding: "10px", border: "1px solid black", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)'}}>{language === "English" ? "Deductions" : "कपात:"}</th>
                      <th style={{ padding: "10px", border: "1px solid black", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)'}}>{language === "English" ? "Per(%)" : "टक्केवारी(%):"}</th>
                      <th style={{ padding: "10px", border: "1px solid black", fontWeight:"bold",backgroundColor:'rgba(85, 85, 85, 0.1)'}}>{language === "English" ? "Amount" : "रक्कम:"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Basic Salary

                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {basicSalary}
                      </td>
                  
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Provident Fund

                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {PF}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {calpf}
                      </td>

                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        House Rent Allowance

                      </td>

                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {hra}

                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Employees State Insurance

                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {ESI}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {calesi}

                      </td>

                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Dearness Allowance

                      </td>
                     
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {da}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>Other Deduction

                      </td>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {otherdedu}
                      </td>

                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {otherdedu}
                      </td>

                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Bonus

                      </td>
                     
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {bonus}
                      </td>
                      <td colSpan={4} rowSpan={5} style={{ padding: "10px", border: "1px solid black" }}>

                      </td>


                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Incentive

                      </td>
                     
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {incentive}
                      </td>


                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Overtime

                      </td>
                     
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {overtime}
                      </td>


                    </tr>

                    <tr>
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        Otherearn

                      </td>
                     
                      <td style={{ padding: "10px", border: "1px solid black" }}>
                        {otherearn}
                      </td>
                      </tr>
                       
                       <tr>
                      <td colSpan="1" style={{ padding: "10px", border: "1px solid black", }}>
                        EMI
                      </td>
                      <td style={{ padding: "10px", border: "1px solid black", }}> {EMI} </td>
                      </tr>

                    <tr>
                      <td colSpan="1" style={{ padding: "10px", border: "1px solid black", fontWeight: "bold", backgroundColor:'rgba(85, 85, 85, 0.1)' }}>
                       {language === "English" ? " Gross Earnings" : "एकूण कमाई"}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid black", fontWeight: "bold", backgroundColor:'rgba(85, 85, 85, 0.1)' }}>{calculateTotalEarnings()}</td>


                      <td colSpan={2} style={{ padding: "10px", border: "1px solid black", fontWeight: "bold", backgroundColor:'rgba(85, 85, 85, 0.1)' }}> {language === "English" ? "Total Deductions" : "एकूण कपात"}</td>
                      <td style={{ padding: "10px", border: "1px solid black", fontWeight: "bold", backgroundColor:'rgba(85, 85, 85, 0.1)' }}>{calculateTotalDeductions()}</td>

                    </tr>

                  </tbody>
                </table>

                <div className="foot" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>

                  <label style={{ marginRight: '10px', marginTop:'6px',fontWeight:"bold" }}>{language === "English" ? "Total salary" : "एकूण पगार"}</label>
                  <input type="text" name='total salary' value={calculateTotalSalary()} style={{ border: '1px solid black', width: '130px', padding: '0px 5px', borderRadius: '5px', height: '40px', textAlign: 'center', marginRight: '50px' }} />

                  <label style={{ marginRight: '10px', marginTop:'6px',fontWeight:"bold" }}>{language === "English" ? "Month Days" : "महिन्याचे दिवस"}</label>
                  <input type="text" name='month days' value={monthDays} style={{ border: '1px solid black', width: '130px', padding: '0px 5px', borderRadius: '5px', height: '40px', textAlign: 'center', marginRight: '50px' }} />

                  <label style={{ marginRight: '10px', marginTop:'6px',fontWeight:"bold" }}>Proportional Salary</label>
                  <input type="text" name='proportional salary' value={parseFloat(proportionalSalary).toFixed(2)} style={{ border: '1px solid black', width: '130px', padding: '0px 5px', borderRadius: '5px', height: '40px', textAlign: 'center' }} />

                </div>

               
              </div>
            </div>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <button 
                    onClick={handlePrint}
                    style={{
                      backgroundColor: "#03365e",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      margin: "10px auto",
                      marginTop: "30px",
                    }}
                  >
                    Print
                  </button>

                  <button
                onClick={handleCloseTable}
                style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      margin: "10px auto",
                      marginTop: "30px", marginLeft:'20px'
                    }}
              >
                Close
              </button>
                </div>
            </div>
          </div>
        )}
        </div>

  );
}

export default SalaryDetails;